export const OUT_OF_SCOPE = 'out_of_scope'

export function validCustomerQuantity(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value) && value > 0
}

/** Scale the reviewed aggregate, not its rounded unit price or supplier billing unit. */
export function customerConfigurationCost(lineCost: number | null, sourceQuantity: number, customerQuantity: number) {
  if (lineCost === null || !Number.isFinite(lineCost) || lineCost < 0
    || !validCustomerQuantity(sourceQuantity) || !validCustomerQuantity(customerQuantity)) return null
  const cents = Math.round((lineCost + Number.EPSILON) * 100)
  if (!Number.isSafeInteger(cents)) return null
  const divide = (numerator: bigint, denominator: bigint) => (numerator * 2n + denominator) / (denominator * 2n)
  const scaled = divide(BigInt(cents) * BigInt(customerQuantity), BigInt(sourceQuantity))
  if (scaled > BigInt(Number.MAX_SAFE_INTEGER)) return null
  return {
    lineCost: Number(scaled) / 100,
    unitCost: Number(divide(scaled, BigInt(customerQuantity))) / 100,
  }
}
